import { ROUTES } from "../components/shared/constant";
import { IRouteDetails } from "../common/App.interface";
import {
  WorkforcePeoplePage,
  WorkforceAccessPage,
  WorkforceAssetsHubPage,
  WorkforceDashboardsPage,
  WorkforceReportsPage,
  ApplicationAccessPage,
  ApplicationsPage,
  LifecyclePage,
  LicensesPage,
  PersonProfilePage,
  OrgChartPage,
} from "./workforceLazyComponents";

export function createWorkforceRoutes(): IRouteDetails[] {
  return [
    {
      name: "WorkforcePeople",
      path: ROUTES.WORKFORCE_PEOPLE, // no QUERYPARAMS: avoid colliding with /people/:agentId
      component: WorkforcePeoplePage,
      isRealTimeDataOn: false,
    },
    {
      name: "WorkforceAccess",
      path: ROUTES.WORKFORCE_ACCESS + ROUTES.QUERYPARAMS,
      component: WorkforceAccessPage,
      isRealTimeDataOn: false,
    },
    {
      name: "WorkforceDashboards",
      path: ROUTES.WORKFORCE_DASHBOARDS + ROUTES.QUERYPARAMS,
      component: WorkforceDashboardsPage,
      isRealTimeDataOn: false,
    },
    {
      name: "WorkforcePersonProfile",
      path: ROUTES.WORKFORCE_PERSON + ROUTES.QUERYPARAMS,
      component: PersonProfilePage,
      isRealTimeDataOn: false,
    },
    // Declared AFTER WorkforcePersonProfile so /workforce/people/:agentId
    // isn't shadowed by an org-chart route that doesn't share its prefix.
    {
      name: "WorkforceOrgChart",
      path: ROUTES.WORKFORCE_ORG + ROUTES.QUERYPARAMS,
      component: OrgChartPage,
      isRealTimeDataOn: false,
    },
    // Declared BEFORE the base applications route: `/workforce/applications/:slug`
    // and the base `/workforce/applications/:instanceid?` score-tie in React
    // Router's ranking for a path like `/workforce/applications/skynote`, and
    // ties break by declaration order — the slug detail must win.
    {
      name: "WorkforceApplicationAccess",
      path: ROUTES.WORKFORCE_APPLICATION_ACCESS + ROUTES.QUERYPARAMS,
      component: ApplicationAccessPage,
      isRealTimeDataOn: false,
    },
    // Declared AFTER the `:slug` detail so `/workforce/applications/<slug>`
    // resolves to the detail page, not this base list route.
    {
      name: "WorkforceApplications",
      path: ROUTES.WORKFORCE_APPLICATIONS + ROUTES.QUERYPARAMS,
      component: ApplicationsPage,
      isRealTimeDataOn: false,
    },
    {
      name: "WorkforceLifecycle",
      path: ROUTES.WORKFORCE_LIFECYCLE + ROUTES.QUERYPARAMS,
      component: LifecyclePage,
      isRealTimeDataOn: false,
    },
    {
      name: "WorkforceAssets",
      path: ROUTES.WORKFORCE_ASSETS + ROUTES.QUERYPARAMS,
      component: WorkforceAssetsHubPage,
      isRealTimeDataOn: false,
    },
    {
      name: "WorkforceLicenses",
      path: ROUTES.WORKFORCE_LICENSES + ROUTES.QUERYPARAMS,
      component: LicensesPage,
      isRealTimeDataOn: false,
    },
    {
      name: "WorkforceReports",
      path: ROUTES.WORKFORCE_REPORTS + ROUTES.QUERYPARAMS,
      component: WorkforceReportsPage,
      isRealTimeDataOn: false,
    },
  ];
}
